import React from "react";
import LandingPage from "./components/LandingPage";
import UnderConstructionNotice from "./components/UnderConstructionNotice";
import { LanguageProvider } from "./context/LanguageContext";
import "./App.css";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <UnderConstructionNotice />
        <LandingPage />
      </div>
    </LanguageProvider>
  );
}

export default App;
